import { Media } from './media';

export const ICON_SPRITE_SHEET = "map-styles/icon-sprite-sheet.png";
export const ICON_SPRITE_SHEET_DB = "/iconSpriteSheet";

export class Icon {
    id: string;
    url: string;
}

export class IconSet {
    public key: string = "";
    public title: string = "";
    // Owner project allowed to change the IconSet
    public project: string = "";
    // Firebase time stamp object on or timestamp string
    public createdOn: any = "";

    public moteAvailable: Media;
    public moteUnlocked: Media;
    public moteLocked: Media;
    public moteUser: Media;
    public moteInactive: Media;
    public positionGood: Media;
    public positionBad: Media;
    public routeColor: string;

    public placeholder = "/assets/icons/inactive-mote.png";

    constructor(key: string = null, json: any = {}) {
        this.key = key;
        // Update from json, or just initialize with default values
        this.updateFromJson(json || {});
    }

    public updateFromJson(json: any): void {
        this.title = json.title || "";
        this.project = json.project || "";
        this.createdOn = json.createdOn || null;
        this.moteAvailable = new Media(json.moteAvailable || {}, 'moteAvailable', this.placeholder, "icon");
        this.moteLocked = new Media(json.moteLocked || {}, 'moteLocked', this.placeholder, "icon");
        this.moteUnlocked = new Media(json.moteUnlocked || {}, 'moteUnlocked', this.placeholder, "icon");
        this.moteInactive = new Media(json.moteInactive || {}, 'moteInactive', this.placeholder, "icon");
        this.moteUser = new Media(json.moteUser || {}, 'moteUser', this.placeholder, "icon");
        this.positionGood = new Media(json.positionGood || {}, 'positionGood', this.placeholder, "icon");
        this.positionBad = new Media(json.positionBad || {}, 'positionBad', this.placeholder, "icon");
        this.routeColor = json.routeColor || '#000000';
    }

    public toJson() {
        return {
            title: this.title,
            createdOn: this.createdOn,
            project: this.project,
            moteAvailable: this.moteAvailable.toJson(),
            moteUnlocked: this.moteUnlocked.toJson(),
            moteLocked: this.moteLocked.toJson(),
            moteInactive: this.moteInactive.toJson(),
            moteUser: this.moteUser.toJson(),
            positionGood: this.positionGood.toJson(),
            positionBad: this.positionBad.toJson(),
            routeColor: this.routeColor
        };
    }

    public getIconList(): Icon[] {
        return [
            { "id": this.key + "_moteLocked", "url": this.moteLocked.thumb.url },
            { "id": this.key + "_moteAvailable", "url": this.moteAvailable.thumb.url },
            { "id": this.key + "_moteUnlocked", "url": this.moteUnlocked.thumb.url },
            { "id": this.key + "_moteUser", "url": this.moteUser.thumb.url },
            { "id": this.key + "_moteInactive", "url": this.moteInactive.thumb.url }
        ];
    }

    public getIconStorageList(): Icon[] {
        return [
            { "id": this.key + "_moteLocked", "url": this.moteLocked.thumb.storage || "static-images/icons/mote-locked.png" },
            { "id": this.key + "_moteAvailable", "url": this.moteAvailable.thumb.storage || "static-images/icons/mote-available.png" },
            { "id": this.key + "_moteUnlocked", "url": this.moteUnlocked.thumb.storage || "static-images/icons/mote-unlocked.png" },
            { "id": this.key + "_moteUser", "url": this.moteUser.thumb.storage || this.moteAvailable.thumb.storage || "static-images/icons/mote-inactive.png" },
            { "id": this.key + "_moteInactive", "url": this.moteInactive.thumb.storage || "static-images/icons/mote-inactive.png" }
        ];
    }

    public toString(): string {
        return "IconSet object \nKey: '" + this.key + "' Title: " + this.title + " Created on:" + this.createdOn;
    }
}

export interface MapboxSpriteSheet {
    [key: string]: MapboxSprite
}

export interface MapboxSprite {
    "key": string,
    "x": number,
    "y": number,
    "width": number,
    "height": number,
    "pixelRatio": number
}

export interface SpriteImage {
    sprite: MapboxSprite,
    image: ImageData
}

export interface IconSpriteInfo {
    imageUrl: string,
    spriteSheet: MapboxSpriteSheet
}
